import { useContext, useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';

function Documentation({ question, answerHandler, itemsAnswer, disable }) {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { isLightTheme } = leadGenerationContext;
  const [translation, setTranslation] = useState(leadGenerationContext.productQuestionsEN);
  const classes = ProductUIStyles(leadGenerationContext?.theme);
  useEffect(() => {
    if (leadGenerationContext.language === 'EN') {
      setTranslation(leadGenerationContext.productQuestionsEN);
    }
    if (leadGenerationContext.language === 'ES') {
      setTranslation(leadGenerationContext.productQuestionsES);
    }
  }, [leadGenerationContext.language]);

  let trueValue = false;
  if (itemsAnswer) {
    if (question.name in itemsAnswer) {
      trueValue = itemsAnswer[question.name];
    }
  }

  let eventFound = false;
  if (question.documentation.length > 0) {
    question.documentation.forEach((item) => {
      if (item?.event?.type) {
        eventFound = true;
      }
    });
  }

  const enterKeyHandle = (e) => {
    if (e.key === 'Enter') {
      answerHandler(!trueValue, question);
    }
  };

  if (eventFound) {
    return (
      question.documentation.length > 0 &&
      question.documentation.map((item) => (
        <Grid key={item.description} container size={{ xs: 12 }} style={{ margin: '20px 0' }}>
          <Grid size={{ xs: 2, sm: 1 }} style={{ display: 'flex', alignItems: 'flex-start' }}>
            <div>
              <label className="checkbox-label" htmlFor="checkbox-id">
                <input
                  style={{ margin: '5px' }}
                  data-testid="checkbox_testid"
                  type="checkbox"
                  onChange={() => {
                    answerHandler(!trueValue, question);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      enterKeyHandle();
                    }
                  }}
                  checked={!!trueValue}
                  disabled={disable}
                />
                <span style={{ marginLeft: '2px' }} className="checkbox-custom rectangular" />
              </label>
            </div>
          </Grid>
          <Grid
            size={{ xs: 10, sm: item.event && item.event.type === 'button' ? 8 : 11 }}
            style={{
              fontSize: '13px',
              display: 'flex',
              alignItems: 'flex-start',
            }}
          >
            <Box component="span" sx={classes.docStyle} aria-label={translation[item.description]}>
              {translation[item.description]}
            </Box>
          </Grid>
        </Grid>
      ))
    );
  }
  return (
    <Grid container style={{ margin: '20px 0' }}>
      {question.documentation.length > 0 &&
        question.documentation.map((item) => (
          <Grid key={item.description} container size={{ xs: 12 }} style={{ margin: '10px 0' }}>
            <Grid
              size={{ xs: 2, sm: 1 }}
              style={{ display: 'flex', alignItems: 'flex-start' }}
              sx={question.type === 'Interest' ? classes.consent_checkbox : ''}
            >
              <div>
                <label className={isLightTheme ? 'checkbox_label' : 'checkbox_label_dark'}>
                  <input
                    data-testid="checkbox_testid2"
                    type="checkbox"
                    onChange={() => {
                      answerHandler(!trueValue, question);
                    }}
                    aria-label={translation[item.description]}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        enterKeyHandle();
                      }
                    }}
                    checked={!!trueValue}
                    disabled={disable}
                  />
                  <span
                    style={{
                      opacity: 1,
                      marginLeft: '2px',
                      position: 'relative',
                      top: '3px',
                    }}
                    className={
                      isLightTheme
                        ? 'checkbox_custom rectangular'
                        : 'checkbox_custom_dark rectangular'
                    }
                  />
                </label>
              </div>
            </Grid>
            <Grid size={{ xs: 10, sm: 11 }} style={{ display: 'flex', alignItems: 'center' }}>
              <Box
                component="span"
                sx={classes.docStyle}
                aria-label={translation[item.description]}
              >
                {translation[item.description]}
              </Box>
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
}

Documentation.propTypes = {
  question: PropTypes.object,
  answerHandler: PropTypes.func,
  itemsAnswer: PropTypes.object,
  disable: PropTypes.bool,
};
export default Documentation;
